export default __webpack_public_path__ + "static/media/img2.b34cc9d6.PNG";